export const passwordCheckTypes = {
  toNumber: /(?=.*[0-9])/,
  toLowerCaseAndUpperCase: /^(?=.*[a-z])(?=.*[A-Z]).+$/,
  toSpecialCharacter: /[!@#$%^&*()_+\-={[}\]|\\;:'"<>?,.]/,
  matchSpecialCharacter: /[!@#$%^&*()_+\-={[}\]|\\;:'"<>?,.]/g,
};
